<template>
    <div class="">
        <div class="form-group kt-margin-0 kt-padding-0 w-100">
        <div class="row">
                <div class="col-lg-11 col-10 pr-0">
                    <v-select v-model="fixedExpenseType"
                              :class="addBtn?'vselect-with-btn': ''"
                              label="name"
                              :options="groups"
                              :filterable="false"
                              :placeholder="placeholder"
                              @search="onGroupSearch"
                              @search:focus="onGroupFocus"
                              @input="onGroupChange">
                        <template slot="option" slot-scope="option" v-if="option">
                            <div v-html="option.name"></div>
                        </template>
                        <span slot="no-options">
                                {{$t("empty")}}
                            </span>
                    </v-select>
                </div>
                <div class="col-lg-1 col-2 p-0" v-if="addBtn">
                    <button class="all-btn btn-with-vselect m-0 font-weight-bold w-75 w-md-100" type="button" @click="addFixedExpenseType">...</button>
                </div>
            </div>
        </div>

        <b-modal size="xl" ref="fixed-expense-add-modal" :title="$t(modalTitle)"
                 :cancel-only="true"
                 :ok-only="true"
                 :no-close-on-backdrop="true"
                 :no-close-on-esc="true">
            <Loading v-if="loading"></Loading>

            <fixed-expense-type-list></fixed-expense-type-list>

        </b-modal>
    </div>

</template>
<script>
    import initFilterModel from '@/shared/filter';
    import Loading from "@/components/Loading";
    import bModal from 'bootstrap-vue/es/components/modal/modal'

    import FixedExpenseTypeList from "@/views/finance/debit/FixedExpenseTypeList";

    export default {
        name: "FixedExpenseTypeSelect",
        components: {
            Loading,
            bModal,
            FixedExpenseTypeList
        },
        props: {
            placeholder: String,
            type: String,
            addBtn: {
                type: Boolean,
                default: true
            },
            value: Object,
            parent: Object,
        },
        data() {
            return {
                filter: initFilterModel(),
                fixedExpenseType: null,
                groups: [],
                loading: false,
                modalTitle: 'finance.ipoteka.fixedExpenses.titleExpenseTypeList',
            }
        },
        methods: {
            // addNewGroup(event) {
            //     this.$refs['fixed-expense-add-modal'].hide();
            //     event.preventDefault();
            //
            // },
            addFixedExpenseType() {
                this.$refs['fixed-expense-add-modal'].show();
            },
            getData() {
                const headers = {
                    'lang': localStorage.getItem('x_lang')
                };
                this.$http.post('fixed-expense-type/list', this.filter, {headers})
                    .then(res => {
                        this.loading = false;
                        console.log(res.data);
                        this.groups = res.data.data;
                    }, err => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            onGroupSearch(searchTxt) {
                this.loading = true;
                this.groups = [];
                this.filter.search = searchTxt;
                this.getData();
            },
            onGroupFocus() {
                this.loading = true;
                this.groups = [];
                this.filter.search = null;
                this.getData();
            },
            onGroupChange() {
                this.$emit('input', this.fixedExpenseType);
            },

        },
        created() {
            this.$eventBus.$on('refreshFixedExpenseTypeSelect', (data) => {
                console.log("refreshFixedExpenseTypeSelect = ", data);
                if (data.isNew){
                    this.fixedExpenseType = data.data;
                    this.$refs['fixed-expense-add-modal'].hide();
                }

            })
        },
        mounted() {
            // console.log(this.parentData);
            setTimeout(() => {
                console.log(this.$props.value);
                if (this.$props.value) {
                    this.fixedExpenseType = this.$props.value;
                }
            }, 1000);

        },
    }
</script>

<style scoped>

</style>